module.exports = __webpack_public_path__ + "static/media/summerpack-promo.5e618c96.png";